import React, { Suspense, useEffect, useState } from 'react';
import { subscribeToWidgetRenders } from './ComponentRenderRegistry';
import WidgetPortal from './WidgetPortal';
import { I18nextProvider } from 'react-i18next';
import i18n from '@higherlogic/i18n';

const GlobalContextsContainer = React.lazy(
    () => import(/* webpackChunkName: "GlobalContext"*/ '../Global/GlobalContextsContainer')
);

const RootComponent: React.FCC<{ globalData: GlobalData }> = ({ globalData }) => {
    const [widgetConfigs, setWidgetConfigs] = useState<ReactWidgetConfig[]>([]);

    useEffect(() => {
        return subscribeToWidgetRenders(setWidgetConfigs);
    }, [setWidgetConfigs]);

    return (
        <div className="bootstrap-4">
            <Suspense fallback={null}>
                <I18nextProvider i18n={i18n}>
                    <GlobalContextsContainer globalData={globalData}>
                        {widgetConfigs.map(([compName, reactId, widgetProps, prefetchPromise]) => (
                            <WidgetPortal
                                key={reactId}
                                compName={compName}
                                reactId={reactId}
                                widgetProps={widgetProps}
                                prefetchPromise={prefetchPromise}
                            />
                        ))}
                    </GlobalContextsContainer>
                </I18nextProvider>
            </Suspense>
        </div>
    );
};

export default RootComponent;
